import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";
import ButtonDecor from "../../global/pointandclick/ButtonDecor";

export default class ChiffreCode extends Phaser.GameObjects.Container {
    constructor(scene, x, y, updateFunction) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.value = 0

        this.update = () => {
            updateFunction()
        }

        this.textElmt = this.scene.add.text(0, 0, this.value, {
            fontFamily: FONTS.Inter28ExtraLight,
            fontSize: '212px',
            color: Colors.Text.Black,
        }).setOrigin(0.5);
        this.add(this.textElmt);

        this.buttonPlus = new ButtonDecor(this.scene, 0, -165);
        this.buttonPlus.textElmt.setText("⭡")
        this.buttonPlus.setClickFunction(() => {
            this.increase()
        })
        this.add(this.buttonPlus);

        this.buttonMinus = new ButtonDecor(this.scene, 0, 170);
        this.buttonMinus.textElmt.setText("⭣")
        this.buttonMinus.setClickFunction(() => {
            this.decrease()
        })
        this.add(this.buttonMinus);
    }

    increase(){
        this.value = (this.value + 1) % 10
        this.textElmt.setText(this.value)
        this.update()
    }

    decrease(){
        this.value = (this.value + 9) % 10
        this.textElmt.setText(this.value)
        this.update()
    }
    
    getValue(){
        return this.value
    }

    hidebuttons(){
        this.buttonMinus.disableInteractive();
        this.buttonPlus.disableInteractive();
        this.scene.tweens.add({
            targets: [this.buttonPlus, this.buttonMinus],
            alpha: 0,
            duration: 300,
        })
    }
}